import { CustomerModel, CardModel } from './models';

export const state = {
  customer: new CustomerModel(),
  card: new CardModel(),
  paymentMethod: 'new',
  paymentInfo: {},
  cache: {
    customer: new CustomerModel(),
  },
};

export const mutations = {
  resetCard(state) {
    state.card = new CardModel();
  },
};